const fromQueryPlacePredictionsToPlacePredictions = (data)=>{
    if (!data) {
        return null;
    }
    return data.map(({ id , locality , sublocality  })=>({
            id,
            locality,
            sublocality: sublocality !== null && sublocality !== void 0 ? sublocality : undefined
        })
    );
};

export { fromQueryPlacePredictionsToPlacePredictions as default };
//# sourceMappingURL=fromQueryPlacePredictionsToPlacePredictions.js.map
